module.exports = __webpack_public_path__ + "8227ca588ff89ff00f53181491ab33c4.jpg";